import { ReactNode, useState } from 'react'
import { useLocation } from 'react-router-dom'

import AnnouncementBanner from '../Announcements/AnnouncementBanner'
import AppHeader from './AppHeader'
import AppSidebar, { readCollapsed } from './AppSidebar'
import './AppShell.css'

/**
 * The portal's page frame: the left navigation and the top bar, with the usual
 * announcements. The job portal has no navigation, and the dashboard (a wall
 * display) has neither navigation nor top bar.
 */
const AppLayout = ({
  children,
  userName,
  allowedRoutes,
}: {
  children: ReactNode
  userName: string
  allowedRoutes: string[]
}) => {
  const [collapsed, setCollapsed] = useState(readCollapsed)
  const { pathname } = useLocation()

  const isJobPortal = pathname.startsWith('/job-portal')
  const isDashboard = pathname === '/dashboard'
  const showSidebar = !isJobPortal && !isDashboard
  // The home page lays itself out edge to edge; every other page gets the
  // padding and heading size the old frame gave it.
  const isHome = pathname === '/'

  return (
    <div
      className={`pshell${collapsed ? ' pshell--collapsed' : ''}${showSidebar ? '' : ' pshell--no-sidebar'}`}
    >
      {showSidebar && (
        <AppSidebar allowedRoutes={allowedRoutes} collapsed={collapsed} onCollapsedChange={setCollapsed} />
      )}
      <div className='pshell__main'>
        {!isDashboard && <AppHeader userName={userName} />}
        {!isDashboard && <AnnouncementBanner />}
        <main className={`pshell__content${isHome ? '' : ' pshell__content--page'}`}>{children}</main>
      </div>
    </div>
  )
}

export default AppLayout
